var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "memberResendEmailModal",
      "modal-class": "client-details-modal",
      "centered": "",
      "size": "md",
      "hide-header-close": "",
      "hide-footer": true
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    ref: "resendEmailContainer",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "view-clients-modal-content"
  }, [_c('h6', [_vm._v(" Re-Send Confirmation # " + _vm._s(_vm.member ? _vm.member.policy_id : "") + " Receipt ")]), _c('button', {
    staticClass: "btn univ-btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.sendResendEmail.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isSend ? "Re-Sending Confirmation Receipt" : "Re-Send Confirmation Receipt") + " ")])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }